import React from 'react';
import { MdClose } from 'react-icons/md';
import { Tooltip, Whisper } from 'rsuite';
import { NegotiationSupplierDatapointStatus } from '../../../NegociacaoFornecedor.types';
import styles from './RejectedButton.module.scss';

export interface RejectedButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  currentStatus?: NegotiationSupplierDatapointStatus;
}

export const RejectedButton: React.FC<RejectedButtonProps> = ({ onClick, disabled = false, className = '', currentStatus }) => {
  const isSelected = currentStatus === 'DECLINED';
  const isInactive = currentStatus === 'APPROVED';

  const buttonClass = isSelected
    ? `${styles['rejected-button']} ${styles['rejected-button--selected']} ${className}`
    : isInactive
      ? `${styles['rejected-button']} ${styles['rejected-button--inactive']} ${className}`
      : `${styles['rejected-button']} ${className}`;

  const getIconColor = () => {
    if (isSelected) return '#ffffff'; // White when selected
    if (isInactive) return '#000000'; // Black when inactive
    return '#E34850'; // Red when default
  };

  return (
    <Whisper placement="left" trigger="hover" speaker={<Tooltip>Reprovar preço negociado</Tooltip>}>
      <button className={buttonClass} onClick={onClick} disabled={disabled} type="button">
        <MdClose className={styles['rejected-icon']} color={getIconColor()} />
      </button>
    </Whisper>
  );
};
